import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import io from 'socket.io-client';

import './Pvstatus.css';
import MainCenterGaugeChart from './MainCenterGaugeChart';
import MainBottomVerticalGaugeGraph from './MainBottomVerticalGaugeGraph';
import MainEnSensor from './MainEnSensor';

import Sunrise from '../../image/icons/sunrise.png';
import Sunset from '../../image/icons/sunset.png';
import Timeicon from '../../image/icons/timeicon.png';

import { updateTime } from '../../store';
import config from '../../config';
import useIsMobile from '../../hooks/useIsMobile';
import { Row, Col } from "react-bootstrap";


const socket = io(`${config.backendUrl}`, {
  transports: ['websocket']
}); // 웹소켓 서버 URL

function Pvstatus() {
  const dispatch = useDispatch();
  const systemTime = useSelector((state) => state.systemTime);
  const isMobile = useIsMobile();

  const [gaugeData] = useState({
    gaugeRatio: [60, 40],
    BottomTitle: '발전전력',
    gaugeValue: 50, // 기본값
    gaugeMaxValue: 100 // 기본값
  });

  useEffect(() => {
    socket.on('connect', () => {
      console.log('Connected to WebSocket server');
    });

    socket.on('system_time', (data) => {
      if (data.nowtime) {
        dispatch(updateTime(data)); // Redux 상태 업데이트
        // console.log('Redux 시간 업데이트', data);
      }
    });

    const interval = setInterval(() => {
      socket.emit('request_time');
    }, 1000);

    return () => {
      clearInterval(interval);
      socket.off('system_time');
      socket.off('connect');
    };
  }, [dispatch]);

  const { nowtime, sunrise, sunset } = systemTime;

  let datePart = '';
  let timePart = '';

  if (nowtime) {
    datePart = nowtime.substring(0, nowtime.indexOf(')') + 1);
    timePart = nowtime.substring(nowtime.indexOf(')') + 2);
  } else {
    // 기본값 설정
    datePart = 'Loading date...';
    timePart = 'Loading time...';
  }

  return (
    <div className='main-Public-wrap'>
      <div className='main-pvstatus-wrap'>
        
        {/* 일출/일몰, 현재시간 */}
        <Row className="sunRiseSet-Time-container">
          {/* 일출/일몰 영역 */}
          <Col xs={12} md={6} className="d-flex flex-column align-items-center">
            <div className="sunRiseSet-Box">
              <div className="text-center" style={{ color: "#6B7476", fontSize: isMobile ? "medium" : "x-large", fontWeight: "600" }}>
                ◎ 일출 / 일몰
              </div>             
                <Col xs="auto">
                  <img src={Sunrise} width={isMobile ? "40" : "50"} height={isMobile ? "40" : "50"} alt="Sunrise" style={{ padding: "3px" }}/>
                </Col>
                <Col xs="auto">
                  <span style={{ color: "#6B7476", fontSize: isMobile ? "large" : "xx-large", fontWeight: "600" }}>
                    {sunrise || "Loading..."}
                  </span>
                </Col>
                <Col xs="auto">
                  <img src={Sunset} width={isMobile ? "40" : "50"} height={isMobile ? "40" : "50"} alt="Sunset" style={{ padding: "3px" }}/>
                </Col>
                <Col xs="auto">
                  <span style={{ color: "#6B7476", fontSize: isMobile ? "large" : "xx-large", fontWeight: "600" }}>
                    {sunset || "Loading..."}
                  </span>
                </Col>             
            </div>
          </Col>

          {/* 현재 시간 영역 */}
          <Col xs={12} md={6} className="d-flex flex-column align-items-center">
            <div className="sunRiseSet-Box">
              <Row className="d-flex align-items-center justify-content-center">
                <Col xs="auto">
                  <img src={Timeicon} width="35" height="35" alt="Timeicon" />
                </Col>
                <Col xs="auto">
                  <span style={{ color: "#6B7476", fontSize: isMobile ? "medium" : "x-large", fontWeight: "600", marginRight: "7px" }}>
                    현재 시간
                  </span>
                </Col>
              </Row>
              <Row className="d-flex align-items-center justify-content-center">
                <Col xs="auto">
                  <span style={{ color: "#6B7476", fontSize: isMobile ? "medium" : "xx-large", fontWeight: "600" }}>
                    {datePart}
                  </span>
                </Col>
                <Col xs="auto">
                  <span style={{ color: "#6B7476", fontSize: isMobile ? "medium" : "xx-large", fontWeight: "600" }}>
                    {timePart}
                  </span>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
        {/* 발전량 그래프, 기상센서 */}
        <div 
          className='chart-container' 
          style={{ 
            margin: '0', 
            padding: '0', 
            display: 'flex', 
            justifyContent: 'space-between',
            flexWrap: isMobile ? 'wrap' : 'nowrap',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: isMobile ? 'center' : 'space-between',
            alignItems: 'center',
             }}>
          {/* 발전량 그래프 / 미리 고정된 공간 확보 */}
          <div style={{ width: isMobile ? '100%' : '25%', minHeight: '300px' }}>
            {/* <MainCenterGaugeChart gaugeData={gaugeData} gaugeColor={'#ED5547'} TopTitle={'현재전력'} BottomTitle={'발전전력'} /> */}
            <MainCenterGaugeChart dataType={'nowPower'} gaugeData={gaugeData} />
          </div>
          <div style={{ width: isMobile ? '100%' : '25%', minHeight: '300px' }}>
            <MainCenterGaugeChart dataType={'todayPower'} gaugeData={gaugeData}/>
          </div>
          <div style={{ width: isMobile ? '100%' : '25%', minHeight: '300px' }}>
            <MainCenterGaugeChart dataType={'conEff'} gaugeData={gaugeData}/>
          </div>
          {/* 기상센서 */}
          <div style={{ width: isMobile ? '100%' : '25%', minHeight: '300px' }}>
            <MainEnSensor TopTitle={'기상센서'}/>
          </div>
        </div>
        {/* 하단 그래프 */}
        <div className='Vchart-container'>
          <MainBottomVerticalGaugeGraph />
        </div>
      </div>
    </div>
  );
}

export default Pvstatus;
